/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
module.exports = {
    tag: 'destruction',
    quality: 0.7,
}